import type { FC } from 'react'
import { Box } from '@dhl/theme'
import { Blaze, type BlazeProps } from '@dhl-ui/components'

export const StepDescription: FC<BlazeProps> = ({ sx, ...rest }) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      display: 'flex',
      alignItems: 'center',
      flexBasis: 'fit-content',
      flexDirection: 'column',
      p: (theme) => theme.spacing(2, 2, 3, 2),
    }}
  >
    <Blaze data-testid="setup-wizard-step-blaze" {...rest} sx={{ m: '0 auto', ...sx }} />
  </Box>
)
